module.exports = __webpack_public_path__ + "static/media/pierre-1.fd909dba.jpeg";